module.exports = __webpack_public_path__ + "static/client7-b5882428a054fb39dedc43319455f224.svg";